import indexData from '../assets/idx/index.json'
import Mapping from '../mapping'
import slug from 'speakingurl'
import { ParseDate, ParseFormInputDate, DateObjectToExportDateDecorator } from '../helper'

class Search {
    constructor() {
        this.index = []
        this.resultIndex = []
        this.slugs = {}
        this.filter = {}
        this.buildLookupIndex(indexData)
        this.resultIndex = [...this.index]
    }

    buildLookupIndex(rawIndex) {
        let transform = (...parts) => {
            let c = '' + parts.join(' ')
            c = c.toLowerCase().replace(/[\"\(\)]/g, '').replace(/[,\.\s{2,}]/g, ' ')
            return c
        }

        for (let i = 0; i < rawIndex.length; i++) {
            let date = ParseDate(rawIndex[i][1])
            let row = {
                index:             i,
                id:                rawIndex[i][0],
                date:              rawIndex[i][1],
                dateParsed:        date,
                dateExport:        DateObjectToExportDateDecorator(date),
                content:           rawIndex[i][2],
                headline:          rawIndex[i][3],
                kicker:            rawIndex[i][4],
                subline:           rawIndex[i][5],
                author:            rawIndex[i][6],
                topic:             Mapping.topic.getTextMapByValue(rawIndex[i][7]),
                topicIndex:        rawIndex[i][7],
                object:            Mapping.media.getByValue(rawIndex[i][8]).text,
                objectIndex:       rawIndex[i][8],
                externalObject:    Mapping.media.getByValue(rawIndex[i][8]).external == true,
                text:              Mapping.type.getTextMapByValue(rawIndex[i][9]),
                textIndex:         rawIndex[i][9],
                place:             Mapping.placement.getTextMapByValue(rawIndex[i][10]),
                placeIndex:        rawIndex[i][10],
                illustration:      Mapping.illustration.getByValue(rawIndex[i][11]).text,
                illustrationIndex: rawIndex[i][11],
                pageCount:         rawIndex[i][12],
                page:              rawIndex[i][13],
                slug:              slug(rawIndex[i][3]),
                textsearch:        transform(rawIndex[i][2]),
                titleSearch:       transform(rawIndex[i][3], rawIndex[i][4], rawIndex[i][5])
            }

            this.slugs[row.slug] = i
            this.index.push(row)
        }
    }

    applyFilter(filter) {
        if (!filter) {
            return
        }

        if (!filter.dateRange) {
            filter.dateRange = {begin:'', end:''}
        }

        this.resultIndex = []
        this.filter = filter
        let keywords = filter.keywords ? filter.keywords.toLowerCase().split(" ") : false
        let title = filter.title ? filter.title.toLowerCase().split(" ") : false
        let dateFrom = ParseFormInputDate(filter.dateRange.begin)
        let dateTill = ParseFormInputDate(filter.dateRange.end)

        for (let i = 0; i < this.index.length; i++) {
            // filter keywords
            if (keywords) {
                let score = 0
                for (let k = 0; k < keywords.length; k++) {
                    if (this.index[i].textsearch.indexOf(keywords[k]) > -1) {
                        score++
                    }
                }
                if (score == 0) {
                    continue
                }
            }

            // filter title
            if (title) {
                let score = 0
                for (let k = 0; k < title.length; k++) {
                    if (this.index[i].titleSearch.indexOf(title[k]) > -1) {
                        score++
                    }
                }

                if (score == 0) {
                    continue
                }
            }

            // filter topic
            if (filter.topic > 0 && this.index[i].topicIndex != filter.topic) {
                continue
            }

            // filter text type
            if (filter.textType > 0 && this.index[i].textIndex.indexOf(filter.textType) == -1) {
                continue
            }

            // filter text type
            if (filter.frontPage && this.index[i].page != 1) {
                continue
            }

            // filter placement
            if (filter.placement && this.index[i].placeIndex.indexOf(filter.placement) == -1) {
                continue
            }

            // filter illustrated
            if (filter.illustration == "1" && this.index[i].illustrationIndex == 2) {
                continue
            }

            // filter media
            if (Array.isArray(filter.media) && filter.media.length > 0 && filter.media.indexOf(this.index[i].objectIndex) == -1) {
                continue
            }

            // external media
            if (Array.isArray(filter.externalMedia) && filter.externalMedia.length > 0 && filter.externalMedia.indexOf(this.index[i].objectIndex) == -1) {
                continue
            }

            // filter date range
            if (dateFrom && dateTill) {
                if (this.index[i].dateParsed < dateFrom || this.index[i].dateParsed > dateTill) {
                    continue
                }
            }

            // filter data index
            if (filter.dataIndex && this.index[i].id != filter.dataIndex) {
                continue            
            }

            this.resultIndex.push(this.index[i])
        }
    }

    getResults() {
        return this.resultIndex
    }

    getIndex() {
        return this.index
    }

    getIndexBySlug(name) {
        let idx = this.slugs[name]
        return idx === undefined ? 0 : idx
    }
}


export default new Search()


// WEBPACK FOOTER //
// ./src/search/index.js